/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/jquery.flot/jquery.flot.d.ts" />

namespace Application.Directives {
  'use strict';

  import IBlockComplete = Models.IBlockComplete;
  import Timer = NodeJS.Timer;
  import ThumbnailRetriever = Models.ThumbnailRetriever;
  import IBlock = Application.Models.IBlock;

  export interface ICategoriesModalResult {
    categoriesToAdd: string[];
    categoriesToDelete: string[];
  }

  /**
   * Factory callback type
   */
  declare type BlockActionsDirectiveFactoryCb = (
    modalService: ngModal.IModalService,
    $interval: angular.IIntervalService,
    connectionRoomService: Services.ConnectionRoomService,
    videoFeedService: Services.VideoFeedService,
    deviceGuiService: Services.DeviceGuiService,
    backendService: Services.BackendService,
    $sce: ng.ISCEService,
    $filter: ng.IFilterService,
    healthService: Services.HealthService,
    $timeout: ng.ITimeoutService,
    userService: Services.UserService,
    aclService: Services.AclService,
    networkNodeService: Services.NetworkNodeService,
    networkNodeTypeService: Services.NetworkNodeTypeService,
    stompService: Services.StompService,
    blockService: Services.BlockService,
    $rootScope: Services.IFlexSettings
  ) => BlockActionsDirective;

  /**
   * Custom scope
   */
  export interface IBlockActionsDirectiveScopeDef {
    block: string;
    toggleLockedBlock: string;
    categories: string;
    refreshCategories: string;
    selectedBlocks: string;
    remove: string;
    selectBlock: string;
    getBlockName: string;
    onThumbnailChanged: string;
    connectedDevices: string;
    streamIdMap: string;
    editionMode: string;
  }

  /**
   * Custom scope
   */
  export interface IBlockActionsDirectiveScope extends ng.IScope {
    block: IBlockComplete;
    toggleLockedBlock: (block: IBlockComplete) => void;
    categories: Models.ICategory[];
    refreshCategories: (result: Object) => void;
    selectedBlocks: Controllers.ISelectedBlocks;
    remove: () => void;
    selectBlock: (block: IBlockComplete) => void;
    getBlockName: (block: Object) => Models.IConnectionRoomBlock;
    onThumbnailChanged: (args: Object) => void;
    connectedDevices: Models.IConnectedBlock[];
    streamId: number;
    streamIdMap: Models.IStreamIdMap;
    editionMode: boolean;
    deviceGui: Models.DeviceGui;
    getRedundantGroupNames: () => string;
    getForwardVtsdBlock: () => void;
    probePermissions: Models.IEvaluatedAcl;
    connectionMode: boolean;
    selectingBlock: (block: IBlockComplete) => void;
    probeLink: string;
    thumbnail: string;
    previousVideoFeedStatus: Models.VideoFeedStatus;
    lastThumbnailRequest: number;
    THUMBNAIL_FAIL_IMG: string;
    THUMBNAIL_LOADING_IMG: string;
    thumbnailRetriever: ThumbnailRetriever;
    /** @deprecated Play stream functionality is deprecated temporarily for performance reasons */
    showVideo: () => void;
    /** @deprecated Play stream functionality is deprecated temporarily for performance reasons */
    showVideoPrompt: () => void;
    videoFeed: Models.IVideoFeed;
    loadThumbnail: (forceRefresh?: boolean) => void;
    videofeedTimer: angular.IPromise<void>;
    selected: boolean;
    checkBlockSelection: () => void;
    selectedDestinationIsConnected: boolean;
    launchCategoriesModal: () => void;
    generatedConnectedDevicesTooltip: string;
    generatedCategoriesTooltip: string;
    showContactInfo: () => void;
    openDeviceGui: () => void;
    nodeGuiUrl: string;
    initialVideoFeedLoad: boolean;
    isTsStream: boolean;
    probeStyle: string;
    showDeviceGuiButton: () => boolean;
    allowStreamPlay: boolean;
    recentlyConnected: boolean;
    recentlyConnectedTimer: Timer;
    probeTooltipText: string;
    validateSelection: () => boolean;
    selectedGroupRoom: boolean;
  }

  export class BlockActionsDirective implements ng.IDirective {
    public static $name: string = 'blockActions';

    private static THUMBNAIL_LOADING_IMG: string =
      'images/thumbnail-loading.png';
    private static THUMBNAIL_FAIL_IMG: string = 'images/thumbnail-fail.png';
    // private static LOAD_VIDEOFEED_DELAY: number = 1000;

    public link: (
      scope: IBlockActionsDirectiveScope,
      element: JQuery,
      attrs: ng.IAttributes
    ) => void;
    public restrict: string = 'AE';
    public replace: boolean = true;
    public transclude: boolean = false;
    public templateUrl: string = 'decorators/block-actions-directive.html';
    public scope: IBlockActionsDirectiveScopeDef = {
      block: '=',
      toggleLockedBlock: '&',
      categories: '=',
      refreshCategories: '&',
      selectedBlocks: '=',
      remove: '&',
      selectBlock: '&',
      getBlockName: '&',
      onThumbnailChanged: '&',
      connectedDevices: '=',
      streamIdMap: '=',
      editionMode: '='
    };

    private videoPlayerModal: ngModal.IModalObject;

    private VIDEOFEED_TIMER_MS: number = 5000;
    private TSPROBE_TIMER_MS: number = 40000;
    private THUMBNAIL_REQUEST_THRESHOLD: number = 8000;
    private RECENTLY_CONNECTED_TIMER: number = 15000;
    private selectedGroupRoom: boolean;

    /**
     * Factory for the directive
     */
    public static Factory(): BlockActionsDirectiveFactoryCb {
      let directive: BlockActionsDirectiveFactoryCb = (
        modalService: ngModal.IModalService,
        $interval: angular.IIntervalService,
        connectionRoomService: Services.ConnectionRoomService,
        videoFeedService: Services.VideoFeedService,
        deviceGuiService: Services.DeviceGuiService,
        backendService: Services.BackendService,
        $sce: ng.ISCEService,
        $filter: ng.IFilterService,
        healthService: Services.HealthService,
        $timeout: ng.ITimeoutService,
        userService: Services.UserService,
        aclService: Services.AclService,
        networkNodeService: Services.NetworkNodeService,
        networkNodeTypeService: Services.NetworkNodeTypeService,
        stompService: Services.StompService,
        blockService: Services.BlockService,
        $rootScope: Services.IFlexSettings
      ) => {
        return new BlockActionsDirective(
          modalService,
          $interval,
          connectionRoomService,
          videoFeedService,
          deviceGuiService,
          backendService,
          $sce,
          $filter,
          healthService,
          $timeout,
          userService,
          aclService,
          networkNodeService,
          networkNodeTypeService,
          stompService,
          blockService,
          $rootScope
        );
      };
      directive.$inject = [
        'ModalService',
        '$interval',
        'connectionRoomService',
        'videoFeedService',
        'deviceGuiService',
        'backendService',
        '$sce',
        '$filter',
        'healthService',
        '$timeout',
        'userService',
        'aclService',
        'networkNodeService',
        'networkNodeTypeService',
        'stompService',
        'blockService',
        '$rootScope'
      ];
      return directive;
    }

    /**
     * Constructor
     */
    constructor(
      private modalService: ngModal.IModalService,
      private $interval: angular.IIntervalService,
      private connectionRoomService: Services.ConnectionRoomService,
      private videoFeedService: Services.VideoFeedService,
      private deviceGuiService: Services.DeviceGuiService,
      private backendService: Services.BackendService,
      private $sce: ng.ISCEService,
      private $filter: ng.IFilterService,
      private healthService: Services.HealthService,
      private $timeout: ng.ITimeoutService,
      private userService: Services.UserService,
      private aclService: Services.AclService,
      private networkNodeService: Services.NetworkNodeService,
      private networkNodeTypeService: Services.NetworkNodeTypeService,
      private stompService: Services.StompService,
      private blockService: Services.BlockService,
      private $rootScope: Services.IFlexSettings
    ) {
      this.modalService = modalService;
      BlockActionsDirective.prototype.link = (
        $scope: IBlockActionsDirectiveScope,
        element: JQuery,
        attrs: ng.IAttributes
      ) => {
        if (
          $scope.videoFeed === undefined ||
          JSON.stringify($scope.videoFeed) ===
            JSON.stringify(Models.VideoFeed.Empty())
        ) {
          this.loadVideoFeed($scope, connectionRoomService);
        }
        if ($scope.block.networkNode.health === undefined) {
          let nodeHref: string = Common.Utils.getSimplifiedHrefFromString(
            $scope.block.networkNode.href
          );
          $scope.block.networkNode.health = this.healthService.getNodeHealth(
            nodeHref
          );
        }
        if ($scope.nodeGuiUrl === undefined) {
          if (
            $scope.block.networkNode &&
            $scope.block.networkNode.href &&
            $scope.block.networkNode.href !== ''
          ) {
            let nodeId: number = Common.Utils.idFromHref(
              $scope.block.networkNode.href
            );
            aclService.canAccessGui(nodeId).then((canAccessGui: boolean) => {
              if (canAccessGui) {
                deviceGuiService
                  .getDeviceGuiByIdPromiseGrouping(nodeId)
                  .then((deviceGui: Models.DeviceGui) => {
                    $scope.deviceGui = deviceGui;
                    if (
                      deviceGui !== undefined &&
                      deviceGui.guiUrl !== undefined &&
                      deviceGui.proxyType !== 'HOST_DISABLED'
                    ) {
                      $scope.nodeGuiUrl = $sce.trustAsResourceUrl(
                        deviceGui.guiUrl
                      );
                    }
                  });
              }
            });
          }
        }

        $scope.probeLink = '';
        $scope.openDeviceGui = (): void => {
          if (
            $scope.probeLink !== '' &&
            ($scope.block.networkNodeTypeHref ===
              '' + Models.VTS_NETWORK_NODE_TYPE ||
              $scope.block.networkNodeTypeHref ===
                '' + Models.VTD_NETWORK_NODE_TYPE)
          ) {
            window.open($scope.probeLink, '_blank');
          } else if ($scope.nodeGuiUrl !== undefined) {
            let deviceGui: Models.DeviceGui = new Models.DeviceGui();
            deviceGui.guiUrl = $scope.nodeGuiUrl.toString();
            deviceGui.proxyType = this.$rootScope.backendConfig.flexoProxyType;
            deviceGuiService.notifyAdminSettingsAttempt(
              Common.Utils.strIdFromHref($scope.block.networkNode.href),
              deviceGui
            );
            window.open($scope.nodeGuiUrl.toString(), '_blank');
          }
        };

        $scope.showDeviceGuiButton = (): boolean => {
          return $scope.block.networkNode.type.name !== 'IKUSNET-QUAD';
        };

        $scope.selectingBlock = (block: IBlockComplete) => {
          $scope.selectBlock(block);
        };

        $scope.initialVideoFeedLoad = false;
        $scope.previousVideoFeedStatus = Models.VideoFeedStatus.OFFLINE;
        $scope.lastThumbnailRequest = 0;
        $scope.THUMBNAIL_FAIL_IMG = BlockActionsDirective.THUMBNAIL_FAIL_IMG;
        $scope.THUMBNAIL_LOADING_IMG =
          BlockActionsDirective.THUMBNAIL_LOADING_IMG;
        $scope.thumbnail = BlockActionsDirective.THUMBNAIL_LOADING_IMG;
        $scope.onThumbnailChanged({
          blockHref: Common.Utils.idFromHref($scope.block.href),
          thumbnailUrl: $scope.thumbnail
        });
        $scope.recentlyConnected = false;

        $scope.checkBlockSelection = (): void => {
          $scope.selected = false;
          if ($scope.block.type === 'source') {
            if ($scope.selectedBlocks.selectedSource) {
              $scope.selected =
                $scope.block.id === $scope.selectedBlocks.selectedSource.id;
            }
            if ($scope.selectedBlocks.selectedDestination) {
              this.checkSelectedDestinationIsConnected($scope);
            } else {
              $scope.selectedDestinationIsConnected = false;
            }
          } else {
            if ($scope.selectedBlocks.selectedDestination) {
              $scope.selected =
                $scope.block.id ===
                $scope.selectedBlocks.selectedDestination.id;
            }
          }
        };

        $scope.validateSelection = (): boolean => {
          if($scope.block.type == 'destination' && $scope.block.locked) {
            return true;
          }
          if($scope.block.type == 'source' && $scope.selectedGroupRoom) {
            return false; 
          }else{
          return $scope.block.type === 'source' && ($scope.selectedBlocks.selectedDestination === undefined || $scope.selectedDestinationIsConnected)
                  || $scope.block.type === 'destination' && $scope.block.locked
                }
        }

        $scope.showVideo = (): void => {
          modalService
            .showModal({
              templateUrl: Controllers.VideoPlayerModalController.templateUrl,
              controller: Controllers.VideoPlayerModalController.$name,
              inputs: {
                streamURL: $scope.videoFeed.videoUrl,
                live: true,
                blockId: $scope.block.id,
                videoFeed: $scope.videoFeed
              }
            })
            .then((modal: ngModal.IModalObject) => {
              let videoPlayerModalElem: UIkit.ModalElement;
              videoPlayerModalElem = UIkit.modal(
                Controllers.VideoPlayerModalController.ID,
                { bgclose: false, modal: false, keyboard: false }
              );
              videoPlayerModalElem.show();
              this.videoPlayerModal = modal;
              modal.close.then(() => {
                videoPlayerModalElem.hide();
                this.videoPlayerModal = undefined;
              });
            });
        };

        $scope.showVideoPrompt = (): void => {
          $scope.allowStreamPlay = userService
            .getCurrentUser()
            .authorities.some((auth: Models.IAuthority) => {
              return auth.authority === 'ROLE_ADMIN';
            });

          if ($scope.allowStreamPlay) {
            modalService
              .showModal({
                templateUrl: Controllers.ConfirmModalController.templateURL,
                controller: Controllers.ConfirmModalController.$name,
                inputs: {
                  title: 'Stream play',
                  description:
                    'Playing the stream could affect the ongoing transmission. Do you want to continue?',
                  name: '',
                  type: 'warning'
                }
              })
              .then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(
                  Controllers.ConfirmModalController.ID,
                  { bgclose: false, modal: false, keyboard: false }
                );
                modalElem.show();
                modal.close.then((result: Object) => {
                  modalElem.hide();
                  if (result) {
                    // notifies the backend
                    videoFeedService.notifyVideoPlayAttemptByBlockId(
                      $scope.block.id.toString(),
                      $scope.videoFeed
                    );
                    $scope.showVideo();
                  }
                });
              });
          } else {
            modalService
              .showModal({
                templateUrl: Controllers.InfoModalController.templateURL,
                controller: Controllers.InfoModalController.$name,
                inputs: {
                  title: 'Stream play',
                  description:
                    'Playing the stream is only allowed for Administrator profiles'
                }
              })
              .then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(
                  Controllers.InfoModalController.ID,
                  { bgclose: false, modal: false, keyboard: false }
                );
                modalElem.show();
                modal.close.then((result: Object) => {
                  modalElem.hide();
                });
              });
          }
        };

        $scope.$on('$destroy', () => {
          $interval.cancel($scope.videofeedTimer);
          if ($scope.recentlyConnectedTimer !== undefined) {
            clearTimeout($scope.recentlyConnectedTimer);
          }
          if ($scope.thumbnailRetriever) {
            $scope.thumbnailRetriever.close();
          }
        });

        $interval.cancel($scope.videofeedTimer);
        $scope.videofeedTimer = $interval(() => {
          this.loadVideoFeed($scope, connectionRoomService);
        }, this.VIDEOFEED_TIMER_MS);

        $scope.loadThumbnail = (forceRefresh?: boolean): void => {
          if ($scope.videoFeed.status !== Models.VideoFeedStatus.ERROR) {
            if ($scope.videoFeed.thumbnailUrl !== '') {
              if ($scope.videoFeed.forceRefreshThumbnail || forceRefresh) {
                $scope.thumbnail =
                  $scope.videoFeed.thumbnailUrl +
                  '?&' +
                  Common.Utils.getCurrentTimestamp();
              } else {
                $scope.thumbnail = $scope.videoFeed.thumbnailUrl;
              }
            } else $scope.thumbnail = BlockActionsDirective.THUMBNAIL_FAIL_IMG;

            $scope.onThumbnailChanged({
              blockHref: $scope.block.id,
              thumbnailUrl: $scope.thumbnail
            });
          }
        };

        $scope.getRedundantGroupNames = (): string => {
          if (!$scope.block.config.redundancyGroup) return;
          return (
            $scope.block.config.redundancyGroup.primary +
            '<br>' +
            $scope.block.config.redundancyGroup.redundant
          );
        };
        $scope.launchCategoriesModal = () => {
          this.modalService
              .showModal({
                templateUrl: Controllers.CategoryModalController.templateUrl,
                controller: Controllers.CategoryModalController.$name,
                inputs: {
                  blockCategories: $scope.block.categories,
                  allCategories: $scope.categories
                }
              })
              .then((modal: ngModal.IModalObject) => {
                let categoryModalElement: UIkit.ModalElement = UIkit.modal(
                    Controllers.CategoryModalController.ID,
                    { bgclose: false, modal: false, keyboard: false }
                );
                categoryModalElement.show();
                modal.scope.loadSelectize();
                modal.close.then((result: ICategoriesModalResult) => {
                  categoryModalElement.hide();
                  if (result)
                    $scope.refreshCategories({
                      block: $scope.block,
                      newCategories: result
                    });
                });
              });
        };
        $scope.getForwardVtsdBlock = async () => {
          const vtsdBlockName = await this.getVtsdForwardBlockName($scope.block);
          this.modalService.showModal({
            templateUrl: Controllers.InfoModalController.templateURL,
            controller: Controllers.InfoModalController.$name,
            inputs: {
              title: 'Forward block',
              description: 'Name: ' + vtsdBlockName,
            },
          }).then((modal: ngModal.IModalObject) => {
            let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.InfoModalController.ID,
                {bgclose: false, modal: false, keyboard: false});
            modalElem.show();
            modal.close.then((result: Object) => {
              modalElem.hide();
            });
          });
        };

        $scope.generatedConnectedDevicesTooltip = this.generateConnectedDevicesTooltip(
          $filter,
          Common.Utils.orderArrayByKey($scope.connectedDevices, 'name')
        );
        $scope.generatedCategoriesTooltip = this.generateCategoriesTooltip(
          $filter,
          $scope.block
        );

        $scope.$watch(
          'connectedDevices',
          (
            newValue: Models.IConnectedBlock[],
            oldValue: Models.IConnectedBlock[]
          ) => {
            // Filter connectedDevices to avoid duplicates when removing or adding an encoder in the matrix room with redundancy
            let connectedDevicesWithoutDuplicates: Models.IConnectedBlock[] = $scope.connectedDevices.reduce((unique, o) => {
              if (!unique.some(obj => obj.id === o.id )) {
                unique.push(o);
              }
              return unique;
            }, []);
            $scope.connectedDevices = connectedDevicesWithoutDuplicates;
            if (newValue !== oldValue) {
              $scope.recentlyConnected = true;

              if ($scope.recentlyConnectedTimer !== undefined) {
                clearTimeout($scope.recentlyConnectedTimer);
              }
              $scope.generatedConnectedDevicesTooltip = this.generateConnectedDevicesTooltip(
                $filter,
                Common.Utils.orderArrayByKey(newValue, 'name')
              );
              this.checkSelectedDestinationIsConnected($scope);

              $scope.recentlyConnectedTimer = setTimeout(() => {
                $scope.recentlyConnected = false;
              }, this.RECENTLY_CONNECTED_TIMER);
              this.loadVideoFeed($scope, connectionRoomService);
            }
          },
          true
        );

        $scope.$watch(
          'selectedBlocks',
          (newValue: Object, oldValue: Object) => {
            $scope.checkBlockSelection();
          },
          true
        );

        $scope.isTsStream = this.isTsStream($scope.block);

        $scope.$watch(
          'block',
          (newValue: IBlockComplete, oldValue: IBlockComplete) => {
            $scope.isTsStream = this.isTsStream(newValue);
            if (
              newValue.connectionStatus === 'CONNECTING' ||
              (newValue.connectionStatus === 'CONNECTED' &&
                oldValue.connectionStatus === 'CONNECTING')
            ) {
              this.loadVideoFeed($scope, connectionRoomService, true);
            }
            if (newValue) {
              $scope.generatedCategoriesTooltip = this.generateCategoriesTooltip(
                $filter,
                newValue
              );
            }
          },
          true
        );

        $scope.$watch(
          'connectionMode',
          (newValue: boolean, oldValue: boolean) => {
            if (newValue === false) {
              $scope.selected = false;
            }
          }
        );

        $scope.showContactInfo = () => {
          this.modalService
            .showModal({
              templateUrl: Controllers.InfoModalController.templateURL,
              controller: Controllers.InfoModalController.$name,
              inputs: {
                title: 'Device contact information',
                description: $scope.block.networkNode.contactInfo
              }
            })
            .then((modal: ngModal.IModalObject) => {
              let modalElem: UIkit.ModalElement = UIkit.modal(
                Controllers.InfoModalController.ID,
                { bgclose: false, modal: false, keyboard: false }
              );
              modalElem.show();
              modal.close.then((result: Object) => {
                modalElem.hide();
              });
            });
        };

        $scope.$on('connectionGroupRoom', (event: ng.IAngularEvent, args: Models.IConnectionRoomGroup) => { 
          $scope.selectedGroupRoom = args.name != '';
        });
      };
    }

    private isTsStream(block: IBlockComplete): boolean {
      if (block) {
        if (block.type !== 'source') {
          for (let bConnection of block.blockConnections) {
            if (
              bConnection.direction === 'INPUT' &&
              bConnection.connectionTypeName === 'TSoIP' &&
              this.isMulticast(block)
            ) {
              return true;
            }
          }
        }
        for (let bConnection of block.blockConnections) {
          if (
            bConnection.direction === 'OUTPUT' &&
            bConnection.connectionTypeName === 'TSoIP' &&
            this.isMulticast(block)
          ) {
            return true;
          }
        }
        return false;
      }
      return false;
    }

    private loadVideoFeed(
      scope: IBlockActionsDirectiveScope,
      connectionRoomService: Services.ConnectionRoomService,
      forceRefresh: boolean = false
    ): void {
      if (scope.block !== undefined) {
        if (scope.initialVideoFeedLoad || forceRefresh) {
          scope.initialVideoFeedLoad = false;
          let videoFeed: Models.IVideoFeed = scope.block.videoFeed;
          if (videoFeed && !forceRefresh) {
            if (videoFeed.status !== Models.VideoFeedStatus.ERROR) {
              scope.videoFeed = videoFeed;
              scope.loadThumbnail();
            }
          } else {
            connectionRoomService.getVideoFeedByBlockIdNoList(
              scope.block.id.toString(),
              (videoFeed: Models.VideoFeed) => {
                if (videoFeed.status !== Models.VideoFeedStatus.ERROR) {
                  scope.videoFeed = videoFeed;
                  scope.loadThumbnail(forceRefresh);
                }
              }
            );
          }
        } else {
          connectionRoomService.getVideoFeedByBlockId(
            scope.block.id.toString(),
            (videoFeed: Models.VideoFeed) => {
              if (videoFeed.status !== Models.VideoFeedStatus.ERROR) {
                scope.videoFeed = videoFeed;

                let statusChanged: boolean = false;
                if (scope.previousVideoFeedStatus !== videoFeed.status) {
                  scope.previousVideoFeedStatus = videoFeed.status;
                  statusChanged = true;
                }
                const currentTimestamp: number = Date.now();
                if (
                  scope.recentlyConnected ||
                  statusChanged ||
                  currentTimestamp - scope.lastThumbnailRequest >
                    this.THUMBNAIL_REQUEST_THRESHOLD
                ) {
                  scope.lastThumbnailRequest = currentTimestamp;
                  scope.loadThumbnail();
                }
              }
            }
          );
        }
      }
    }

    private isMulticast(block: IBlockComplete): boolean {
      return (
        (block.type === 'destination' &&
          block.networkNodeTypeHref === '' + Models.VTD_NETWORK_NODE_TYPE) ||
        (typeof block.config.ts !== 'undefined' &&
        typeof block.config.ts.ip !== 'undefined'
          ? Common.IpUtils.ipIsMulticast(block.config.ts.ip)
          : false)
      );
    }

    private generateConnectedDevicesTooltip(
      $filter: ng.IFilterService,
      connectedDevices: Models.IConnectedBlock[]
    ) {
      let tooltipHTML: string;
      let connectedDevicesWithoutDuplicates: Models.IConnectedBlock[] = connectedDevices.reduce((unique, o) => {
        if (!unique.some(obj => obj.id === o.id )) {
          unique.push(o);
        }
        return unique;
      }, []);
      connectedDevices = connectedDevicesWithoutDuplicates;
      if (connectedDevices && connectedDevices.length > 0) {
        tooltipHTML = '<p>Connected to ' + connectedDevices.length + ' device';
        tooltipHTML += connectedDevices.length > 1 ? 's:</p>' : ':</p>';
        tooltipHTML += '<p>';
        connectedDevices.forEach((device: Models.IConnectedBlock) => {
          tooltipHTML +=
            '<i>' +
            $filter<Filters.IEscapeHtmlFilter>('escapeHtml')(device.name) +
            '</i></br>';
        });
        tooltipHTML += '</p>';
      } else {
        tooltipHTML = 'Loading...';
      }
      return tooltipHTML;
    }

    private generateCategoriesTooltip(
      $filter: ng.IFilterService,
      block: IBlockComplete
    ) {
      let tooltipHTML: string;
      if (
        block.categories === undefined ||
        block.categories.length === 0 ||
        (block.categories.length === 1 &&
          block.categories[0].name === Models.BlocksFilter.UNCATEGORIZED)
      ) {
        tooltipHTML = '<i>' + Models.BlocksFilter.UNCATEGORIZED + '</i>';
      } else {
        tooltipHTML = '<p>Categories: </p>';
        tooltipHTML += '<p>';
        block.categories.forEach((category: Models.Category) => {
          tooltipHTML +=
            '<i>' +
            $filter<Filters.IEscapeHtmlFilter>('escapeHtml')(category.name) +
            '</i></br>';
        });
        tooltipHTML += '</p>';
      }
      return tooltipHTML;
    }

    /**
     * check block in case it needs to show red border (selected or currently connected)
     * works for econder and decoder blocks
     * @param $scope
     */
    private async checkSelectedDestinationIsConnected(
      $scope: IBlockActionsDirectiveScope
    ): Promise<void> {
      $scope.selectedDestinationIsConnected = false;
      let redundancySelection = false;
      if ($scope.connectedDevices && $scope.connectedDevices.length > 0) {
        for (const connectedDevice of $scope.connectedDevices) {
          if ($scope.selectedBlocks.selectedDestination) {
            redundancySelection = await this.checkRedundancySelection(
              $scope.selectedBlocks.selectedDestination,
              connectedDevice
            );
          }
          if (
            $scope.selectedBlocks.selectedDestination &&
            (connectedDevice.id ===
              $scope.selectedBlocks.selectedDestination.id ||
              redundancySelection)
          ) {
            $scope.selectedDestinationIsConnected = true;
          }
        }
      }
    }

    /**
     * check if decoder block selected and decoder block connected to current encoder block
     * belongs to the same redundant connection
     * @param selectedDestination decoder block selected
     * @param connectedDestination decoder block connected to current encoder block
     */
    private async checkRedundancySelection(
      selectedDestination: any,
      connectedDestination: any
    ): Promise<boolean> {
      if (selectedDestination.nodeType.name != 'ATEME-DR5000') {
        return false;
      } else {
        let a = await this.blockService.getRedundantBlocks(
          selectedDestination.id
        );
        if (
          a.secondaryDecoderBlock &&
          connectedDestination.id == a.secondaryDecoderBlock.id
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
    private async getVtsdForwardBlockName(block: IBlock): Promise<string> {
      const vtsdForwardBlock: IBlock = await this.blockService.findById(block.config.forwardBlockId);
      return vtsdForwardBlock.name;
    }
  }
}
